import { render, staticRenderFns } from "./wechatAdvertManageList.vue?vue&type=template&id=27743d51&scoped=true"
import script from "./wechatAdvertManageList.vue?vue&type=script&lang=js"
export * from "./wechatAdvertManageList.vue?vue&type=script&lang=js"
import style0 from "./wechatAdvertManageList.vue?vue&type=style&index=0&id=27743d51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27743d51",
  null
  
)

export default component.exports